"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_paper_1 = require("react-native-paper");
const boxTitleStyles_1 = __importDefault(require("./boxTitleStyles"));
const BoxTitle = ({ title }) => react_1.default.createElement(react_native_paper_1.Title, { style: boxTitleStyles_1.default.text }, title);
exports.default = BoxTitle;
